<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('meta.sensors'), name: 'company_sensors' }, { text: $t('sensors.addSensor') }]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('sensors.addSensor') }}</h3>
          </header>
          <div class="content-body">
            <SensorForm @submit="createSensor" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SensorForm from '@/views/companies/sensors/form'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import sensorsApi from '@/api/sensors'

export default {
  name: 'new_container_sensor',
  inject: ['companyUser'],
  components: {
    BreadCrumbs,
    CompanyNav,
    SensorForm,
    SectionHeader,
  },
  methods: {
    async createSensor(sensor) {
      const createdSensor = await sensorsApi.create({
        ...sensor,
        company_uuid: this.companyUser.company_uuid,
      })
      if (createdSensor) await this.$router.push(`/company/sensors`)
    },
  },
}
</script>
